export default function StaffAssignedParticipants(props) {
  return (
    <div className="box-container">
      <div className="box-rsi">
        <span className="rsi-number">{props?.assignedParticipants}</span>
        <span className="rsi-label">Assigned Participants</span>
      </div>
    </div>
  )
}
